export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_4-a1c2a1cf435b1beb751098f0b6e205cd.jpg";